import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect.js'
import AppFav from '../app-fav'

export default
{
    components:
    {
        AppFav
    },

    props:
    {
        content: { type: Object, default: null },
        isV1: { type: Boolean, default: false }
    },

    data()
    {
        return {
            activeIndex: 0,
            subListOffsetX: 0,
            subliftPdfOffsetX: 0,
            title: '',
            slug: ''
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
    },

    mounted()
    {
        this.$share = this.$el.querySelector('.js-share')
        this.$pdf = this.$el.querySelector('.js-pdf')

        this.title = ''
        this.slug = ''

        for(let i = 0; i < this.content.projects.length; i++)
        {
            if(this.content.projects[i].post_name === this.$route.params.postId)
            {
                this.activeIndex = i + 1
                this.title = this.content.projects[i].post_title
                this.slug = this.content.projects[i].post_name
            }
        }

        this.onResize()
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods:
    {
        onToggleList()
        {
            this.$emit('toggle:list')
        },

        onToggleSublistShare()
        {
            this.$el.classList.toggle('is-share-sublist-active')
            this.$el.classList.remove('is-pdf-sublist-active')
        },

        onToggleSublistPdf()
        {
            this.$el.classList.toggle('is-pdf-sublist-active')
            this.$el.classList.remove('is-share-sublist-active')
        },

        onResize()
        {
            if(!this.isV1)
            {
                this.subliftPdfOffsetX = getAbsoluteBoundingRect(this.$pdf).left
                this.subListOffsetX = getAbsoluteBoundingRect(this.$share).left
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-encyclopedia-header/script.js